import GlobalAnalytics from './GlobalAnalytics';
import UmengAnalytics from './UmengAnalytics';

let setAnalyticsTarget = 'GA';

const initialize = (trackingIdUA, trackingIdGA4) => {
  if (setAnalyticsTarget === 'GA') {
    GlobalAnalytics.initialize(trackingIdUA, trackingIdGA4);
  } else {
    UmengAnalytics.initialize();
  }
};

const set = fieldsObject => {
  if (setAnalyticsTarget === 'GA') {
    GlobalAnalytics.set(fieldsObject);
  } else {
    UmengAnalytics.set(fieldsObject);
  }
};

const setDimension = ({ key, value }) => {
  if (setAnalyticsTarget === 'GA') {
    GlobalAnalytics.setDimension({ key, value });
  } else {
    UmengAnalytics.setDimension({ key, value });
  }
};

const setUserId = userId => {
  if (setAnalyticsTarget === 'GA') {
    GlobalAnalytics.setUserId(userId);
  } else {
    UmengAnalytics.setUserId(userId);
  }
};

const registerProperties = propertyObject => {
  if (setAnalyticsTarget === 'GA') {
    GlobalAnalytics.registerProperties(propertyObject);
  } else {
    UmengAnalytics.registerProperties(propertyObject);
  }
};

const setLogCampaignDetails = propertyObject => {
  if (setAnalyticsTarget === 'GA') {
    GlobalAnalytics.setLogCampaignDetails(propertyObject);
  }
};

const unregisterProperties = () => {
  if (setAnalyticsTarget === 'GA') {
    GlobalAnalytics.unregisterProperties();
  }
};

const pageview = ({ path = '', title = '', location = '', otherParams = {} }) => {
  if (setAnalyticsTarget === 'GA') {
    GlobalAnalytics.pageview({ path: path, title: title, location: location, otherParams: otherParams });
  } else {
    UmengAnalytics.pageview({ path: path, title: title, location: location, otherParams: otherParams });
  }
};

const event = async ({ category = '', action, otherParams = {} }) => {
  if (setAnalyticsTarget === 'GA') {
    await GlobalAnalytics.event({ category: category, action: action, otherParams: otherParams });
  } else {
   await UmengAnalytics.event({ category: category, action: action, otherParams: otherParams });
  }
};

const timings = ({ category = '', otherParams = {} }) => {
  if (setAnalyticsTarget === 'GA') {
    GlobalAnalytics.timings({ category: category, otherParams: otherParams });
  } else {
    UmengAnalytics.timings({ category: category, otherParams: otherParams });
  }
};

const exception = ({ message = '', fatal = false }) => {
  if (setAnalyticsTarget === 'GA') {
    GlobalAnalytics.exception({ message: message, fatal: fatal });
  } else {
    UmengAnalytics.exception({ message: message, fatal: fatal });
  }
};

const initializeAnalyticsTarget = ({ analyticsTarget = 'GA', trackingIdUA = '', trackingIdGA4 = '' }) => {
  setAnalyticsTarget = analyticsTarget;
  initialize(trackingIdUA, trackingIdGA4);
};

const logAnalyticsEvent = async({ category = '', eventName, otherParams = {}, eventAction }) => {
  await event({
    category: category,
    action: eventName,
    otherParams: { ...otherParams, ...(eventAction ? { event_action: eventAction } : {}) }
  });
};

const logMoengageEvent = (event,params) =>{
  if (setAnalyticsTarget === 'GA') {
    GlobalAnalytics.logMoengageEvent(event,params);
  } 
}
const logout = () =>{
  if (setAnalyticsTarget === 'GA') {
      GlobalAnalytics.logout();
  } 
}

export default {
  initializeAnalyticsTarget,
  set,
  setDimension,
  setUserId,
  registerProperties,
  unregisterProperties,
  pageview,
  event,
  exception,
  timings,
  logAnalyticsEvent,
  logMoengageEvent,
  logout,
  setLogCampaignDetails
};
